export const IsraelCities = [
  "Acre",
  "Afula",
  "Arad",
  "Ariel",
  "Ashdod",
  "Ashkelon",
  "Bat Yam",
  "Beersheba",
  "Beit She'an",
  "Beit Shemesh",
  "Beit Yehoshua",
  "Bnei Brak",
  "Dimona",
  "Eilat",
  "El'ad",
  "Giv'atayim",
  "Hadera",
  "Haifa",
  "Herzliya",
  "Hod HaSharon",
  "Holon",
  "Jerusalem",
  "Kafr Qasim",
  "Karmiel",
  "Kfar Saba",
  "Kiryat Ata",
  "Kiryat Bialik",
  "Kiryat Gat",
  "Kiryat Malakhi",
  "Kiryat Motzkin",
  "Kiryat Ono",
  "Kiryat Shmona",
  "Lod",
  "Ma'ale Adumim",
  "Ma'alot-Tarshiha",
  "Migdal HaEmek",
  "Modi'in-Maccabim-Re'ut",
  "Modi'in Illit",
  "Nahariya",
  "Nazareth",
  "Nesher",
  "Ness Ziona",
  "Netanya",
  "Netivot",
  "Ofakim",
  "Or Akiva",
  "Petah Tikva",
  "Ra'anana",
  "Rahat",
  "Ramat Gan",
  "Ramat HaSharon",
  "Ramla",
  "Rehovot",
  "Rishon LeZion",
  "Rosh HaAyin",
  "Safed",
  "Sderot",
  "Shefa-'Amr",
  "Tamra",
  "Tayibe",
  "Tel Aviv",
  "Tiberias",
  "Tira",
  "Tirat Carmel",
  "Umm al-Fahm",
  "Yavne",
  "Yehud-Monosson",
  "Yokneam",
  "Zikhron Ya'akov",
  "Zefat",
] as const;
